import Axios from '@/components/api/axios.js'

export default {
	/**
	 * type:HIKVISION
	 */
	createDevice(unitId, deviceName, ip, port, userName, password, type, videoUrl, sort, success, failure) {
		Axios.post('/video/createDevice.do', {
			unitId,
			deviceName,
			ip,
			port,
			userName,
			password,
			type,
			videoUrl,
			sort,
		}, success, failure);
	},
	editDevice(pkid, deviceName, ip, port, userName, password, type, videoUrl, sort, success, failure) {
		Axios.post('/video/editDevice.do', {
			pkid,
			deviceName,
			ip,
			port,
			userName,
			password,
			type,
			videoUrl,
			sort,
		}, success, failure);
	},
	deleteDevice(pkid, unitId, success, failure) {
		Axios.post('/video/deleteDevice.do', {
			pkid,
			unitId,
		}, success, failure);
	},
	searchByUnitId(unitId, success, failure) {
		Axios.post('/video/searchByUnitId.do', {
			unitId,
		}, success, failure);
	},
	/**
	 *	绑定台账设备
	 */
	bindArchives(videoDeviceId, archivesId, success, failure) {
		Axios.post('/video/bindArchives.do', {
			videoDeviceId,
			archivesId
		}, success, failure);
	},
	/**
	 *	解绑 
	 */
	unbingArchvies(relationId, success, failure) {
		Axios.post('/video/unbingArchvies.do', {
			relationId
		}, success, failure);
	},
	/**
	 * 查询摄像头的关联的设备
	 * type传unit是绑定的单位   传archives是台账设备
	 */
	findRelation(videoDeviceId, type, success, failure) {
		Axios.post('/video/findRelation.do', {
			videoDeviceId,
			type
		}, success, failure);
	},

}